import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { fetchCompanyOfficeLocations } from '@/api/v4/organization.api';
import { fetchSpotlightCompanyOfficeLocations } from '@/api/v4/spotlight.api';
import { QueryKey } from '@/config/query-client';

import { companyIdState } from '../../company.state';
import {
  type CompanyFetchMode,
  useCompanyFetchMode,
} from '../../company-fetch-context';

const companyOfficeLocationsFetchers: Record<
  CompanyFetchMode,
  (organizationId: string) => ReturnType<typeof fetchCompanyOfficeLocations>
> = {
  general: fetchCompanyOfficeLocations,
  spotlight: fetchSpotlightCompanyOfficeLocations,
};

export const useOfficeLocationsQuery = () => {
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  const fetchLocations = async () => {
    if (!companyId) return [];

    return companyOfficeLocationsFetchers[fetchMode](companyId);
  };

  return useQuery({
    queryKey: [QueryKey.CompanyOfficeLocations, fetchMode, companyId],
    queryFn: fetchLocations,
    enabled: !!companyId,
    staleTime: 1000 * 60 * 5,
  });
};
